/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import _get from 'lodash/get'
import _merge from 'lodash/merge'
import request from 'api/client/request'
import { tokenService } from 'services/Token'
import { onStartLogoutWithRedirect, onRefreshToken } from 'redux-app/actionCreators/auth'
import { onShowError } from 'redux-app/modules/alerts'
import { getAuthHeaders, getAccessToken } from 'redux-app/selectors/auth'

export const fetchMiddleware = ({ dispatch, getState }) => {
  let isRefreshingToken = false
  let resolvers = []
  const finishRefreshToken = () => {
    isRefreshingToken = false
    resolvers.forEach(resolve => {
      resolve()
    })
    resolvers = []
  }

  return next => action => {
    const { payload, meta, ...restAction } = action
    const { apiAction = false, ...restPayload } = payload || {}

    if (!apiAction) {
      return next(action)
    }

    let promise
    const accessToken = getAccessToken(getState())
    if (!_get(meta, 'noAuth') && accessToken && tokenService.isTokenExpired(accessToken)) {
      promise = new Promise(resolve => {
        resolvers.push(resolve)
      })
        .then(() => request(_merge({}, { headers: getAuthHeaders(getState()) }, apiAction), meta, restAction))

      if (!isRefreshingToken) {
        isRefreshingToken = true
        dispatch(onRefreshToken())
          .then(finishRefreshToken)
          .catch(finishRefreshToken)
      }
    } else {
      const requestApiAction = _merge({}, { headers: getAuthHeaders(getState()) }, apiAction)
      promise = request(requestApiAction, meta, restAction)
    }

    promise = promise.catch(err => {
      if (err.status === 401 && (!meta || meta.handleUnauthorized !== false)) {
        getAccessToken(getState()) && dispatch(onStartLogoutWithRedirect())
      }

      if (err.status === 404 && _get(meta, 'handleNotFound') === true) {
        dispatch(onShowError(err))
      } else if (err.status >= 500 && _get(meta, 'handleServerError') === true) {
        dispatch(onShowError(err))
      }

      throw err
    })

    return next({
      ...restAction,
      meta,
      payload: {
        ...restPayload,
        promise,
      },
    })
  }
}
